import React, { useState, useEffect } from 'react';
import axios from 'axios';
import Swal from 'sweetalert2';
import { BaseURL, uniqueToken } from '../../api/DataApis';
import { Link, useParams } from 'react-router-dom';
import request from '../../Apis/request';
import ReactPaginate from 'react-paginate'; 
import "../Chargers/Charger.css"
import Loader from '../Chargers/Loader';
import "./Statement.css";
import { useLocation } from 'react-router-dom';
import moment from 'moment';
import { useNavigate } from 'react-router-dom';


const SmsLogs = () => {
  document.title = "SMS Logs";
  let Location = useLocation();
  let statementsData = Location?.state?.statementdata;
  let userID = statementsData?._id;
  let navigate = useNavigate();
  let param = useParams();
  // let cid = param.cid




  const [date, setDate] = useState('');
  const [loading, setLoading] = useState(false);
  const [StatementData, setStatementData] = useState([]);
  const [filteredTransactionData, setFilteredTransactionData] = useState([]);
  const [searchTerm, setSearchTerm] = useState('');
  const [userStatuses, setUserStatuses] = useState({});
  const [statusListing, setStatusListing] = useState([]);
  const [page, setPage] = useState(1);
  const [pageCount, setPageCount] = useState(0);
  const [creditTotal, setcreditTotal] = useState(0)
  const [DebitTotal, setDebitTotal] = useState(0)
  const [Wallet, setWallet] = useState(0);
  const [FromDate, setFromDate] = useState("");
  const [ToDate, setToDate] = useState("");
  const [creditdebitStatus, setcreditdebitStatus ] = useState("");
  const [selectedStatus, setSelectedStatus] = useState("");
  const [Limit, setLimit] = useState(20);
  const [TotalCount, setTotalCount] = useState(0);
  const [showListing, setShowListing] = useState(false);
  const [extraRows, setExtraRows] = useState({});
  const [activeRow, setActiveRow] = useState(null);
  const [fruits, setfruits] = useState("Apple, Banana");

  

  const handleReset = (event) => {
    event.preventDefault()
   navigate(`/sms-logs`);
    };

    const toggleRow = async (index, meter) => {
      if (activeRow && activeRow.index === index) {
        // If the clicked row is already active, deactivate it
        setActiveRow(null);
        return;
      }
  
      // Activate the new row with loading state
      setActiveRow({ index, loading: true, data: null, error: null });
  
      try {
        // Fetch additional details using axios
        const response = await axios.get(
          `${BaseURL}/user/statements/order-id/${meter?.transactionId}`,
          {
            headers: {
              "Content-type": "application/json; charset=UTF-8",
              Authorization: `Bearer ${uniqueToken}`,
            },
          }
        );
  
        // Update the activeRow with fetched data
        setActiveRow({ index, loading: false, data: response.data?.data, error: null });
      } catch (error) {
        console.error("Error fetching data:", error);
        // Update the activeRow with error state
        setActiveRow({ index, loading: false, data: null, error: true });
      }
    };
    
    

    const handleInvestClick = () => {
     setShowListing(true); // Show the listing when the button is clicked
    //  alert("hello");
    };

  const handleFromDate = (e) => {
    setFromDate(e.target.value);
}
const handleToDate = (e) => {
  setToDate(e.target.value);
}
const handlepaymentStatus = (e) => {
  setcreditdebitStatus(e.target.value);
}

const handleStatusType = (e) => {
  setSelectedStatus(e.target.value);
}


  const handleSearchChange = (e) => {
    const value = e.target.value.toLowerCase();
    setSearchTerm(value);
  };
console.log("fruits", fruits);
  const fetchSMSLogData = async (currentPage) => {
    setLoading(true);
    let apiEndpoint = `${BaseURL}/smsLog?page=${page}&mobile=${searchTerm}`;

    // Add filters to the API endpoint if they are not empty
    if (FromDate) apiEndpoint += `&from_date=${FromDate} 00:00:00`;
    if (ToDate) apiEndpoint += `&to_date=${ToDate} 23:23:23`;
    if (creditdebitStatus) apiEndpoint += `&statement_type=${creditdebitStatus}`;
    if (selectedStatus) apiEndpoint += `&statement_status=${selectedStatus}`;
    if (Limit) apiEndpoint += `&limit=${Limit}`;

    try {
      const response = await axios.get(apiEndpoint, {
        headers: {
          "Content-type": "application/json; charset=UTF-8",
          Authorization: `Bearer ${uniqueToken}`,
        },
      });

      console.log("response", response);
      setStatementData(response?.data?.data?.data || []);
      setFilteredTransactionData(response?.data?.data?.data || []);
  
      setcreditTotal(response?.data?.creditTotal || 0);
      setWallet(response?.data?.walletamount || 0);
      setDebitTotal(response?.data?.debitTotal || 0);
      setLimit(response?.data?.data?.limit);
      setTotalCount(response?.data?.data?.totalCount);
      // setTotalCount(response.totalCount || 0);
       setPageCount(Math.ceil(response?.data?.data?.totalCount / response?.data?.data?.limit));
    } catch (error) {
      console.error("Error fetching TransactionData:", error);
    } finally {
      setLoading(false);
    }
  };

  // Effect to fetch data on page change
  useEffect(() => {
    fetchSMSLogData(page);
  }, [page]);

  // Handle Filter Submit


  const handlePageClick = (data) => {
    const selectedPage = data.selected + 1;
    setPage(selectedPage);
  };

  const handleSearchSubmit = (e) => {
    e.preventDefault();
    setPage(1);
    fetchSMSLogData(1, searchTerm);
  };
  //meter?.meter_transaction_id
  //meter?.meterTransactions?._id

  

  console.log("filteredTransactionData", filteredTransactionData);
  console.log("creditTotal", creditTotal);
  console.log("debitTotal", DebitTotal);
  console.log("pagecount", pageCount);
  console.log("limit", Limit);
  // console.log("togleData", ToggleData);

  return (
    <div className='container-fluid'>
      <div className='row'>
        <div className='col-sm-12'>
          <div className='card'>
            <div className="portlet-body mx-3">
            <div>
  {/* Header Section */}
  <div className="d-flex justify-content-between align-items-center mb-2">
    <h4>SMS Logs ({TotalCount ? TotalCount : "Loading..."})</h4>
    <form className="form-horizontal" onSubmit={handleSearchSubmit}>
    <div className="row d-flex align-items-center px-3" style={{ gap: "10px" }}>
  {/* Search Input */}
  <div className="col-md-4">
    <input
      type="text"
      placeholder="Find Data Here."
      onChange={handleSearchChange}
      value={searchTerm}
      className="form-control"
      style={{
        height: "38px",
        borderRadius: "34px",
        border: "1px solid black",
        width: "100%", // Ensure it takes full column width
      }}
    />
  </div>

  {/* Search Button */}
  <div className="col-md-3">
    <button
      type="submit"
      className="btn btn-primary w-100"
      style={{
        height: "38px",
        borderRadius: "34px",
      }}
    >
      Search
    </button>
  </div>

  {/* Reset Button */}
  <div className="col-md-3">
    <button
      type="button"
      className="btn btn-secondary w-100"
      style={{
        height: "38px",
        borderRadius: "34px",
      }}
      onClick={handleReset}
    >
      Reset
    </button>
  </div>
</div>

  </form>
  </div>
  <hr style={{ marginTop: "5px" }} />

  {/* Search Form */}
 
</div>



              <div className="card-body" style={{ marginLeft: "-19px" }}>
                {loading ? (
                  <Loader />
                ) : (
                  <>
                    <div className="table-responsive">
                      <table className="display dataTable" style={{ width: '100%', borderCollapse: 'collapse' }} id="advance-1">
                      <thead>
        <tr>
          <th>#</th>
          <th>User Name</th>
          <th>Mobile</th>
          <th>Request</th>
          <th>Response</th>
          <th>CreatedAt</th>
       </tr>
      </thead>
      <tbody>
        {/* Render Original Rows */}
        {filteredTransactionData?.map((meter, index) => (
          <React.Fragment key={index}>
            <tr>
            <td>{(page - 1) * Limit + index + 1}</td>
              <td>{meter?.name[0]}</td>
              <td>{meter?.mobile[0]}</td>
           
              <td><pre>{JSON.stringify(meter.request, null, 2)}</pre></td>
                <td><pre>{JSON.stringify(meter.response, null, 2)}</pre></td>
                <td>{meter?.createdAt}</td>
             </tr>

            {/* Render Extra Row Conditionally */}
  </React.Fragment>
        ))}
      </tbody>
                      </table>
                    </div>

                    <>
              <div className="pagination-container mt-4">
                      <ReactPaginate
                        previousLabel={'Previous'}
                        nextLabel={'Next'}
                        breakLabel={'...'}
                        pageCount={pageCount}
                        marginPagesDisplayed={2}
                        pageRangeDisplayed={5}
                        onPageChange={handlePageClick}
                        containerClassName={'pagination'}
                        subContainerClassName={'pages pagination'}
                        activeClassName={'active'}
                        forcePage={page - 1} 
                      />
                    </div>
               </>
                  </>
                )}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default SmsLogs;
